var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-box __flex __flex_ac __flex_jc"},[_c('div',[[_c('img'),(_vm.haveChange)?_c('div',{staticClass:"__mysupply-box"}):_c('div',{staticClass:"__empty-box"})],_c('div',[_vm._v(_vm._s(_vm.tip))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }